/**
 * @Author ZhangYing
 * @Date 2023-11-13 15:48:08
 * @LastEditors ZhangYing
 * @LastEditTime 2025-11-12 10:41:08
 * @Description
 * @FilePath /BM-Main/src/router/auctionRoom.js
 * @props
 */
import Layout from '@src/Layout'
import { locationReplace } from '@/utils/helper'

// 往组件里注入params和query， 类似react-router
function createPropsFn(defaultQuery = {}) {
  return function(route) {
    return {
      query: Object.assign({}, defaultQuery, route.query)
    }
  }
}

export default {
  path: '/auctionroom',
  component: Layout,
  children: [
    {
      path: 'comment',
      name: 'auctionroom-comment',
      props: createPropsFn(),
      meta: { title: '用户评价' },
      beforeEnter: () => {
        locationReplace('https://m.zhuanzhuan.com/u/bm_common/auctionroom/comment')
      }
    },
    {
      path: ':activityId',
      children: [
        {
          path: '/',
          name: 'auctionroom-item',
          meta: { title: '转转回收', needLogin: true },
          beforeEnter: (to) => {
            const { activityId } = to.params || {}
            locationReplace(`https://m.zhuanzhuan.com/u/bm_common/auctionroom/${activityId}`)
          }
        },
        {
          // todo 这里的 router 不好理解，待优化
          path: 'offer',
          name: 'auctionroom-offer',
          meta: { title: '竞价记录', needLogin: true },
          beforeEnter: (to) => {
            const { activityId } = to.params || {}
            locationReplace(`https://m.zhuanzhuan.com/u/bm_common/auctionroom/${activityId}/offer`)
          }
        }
      ]
    }
  ]
}
